import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { House, Plus, ListChecks, SignOut, Bell } from '@phosphor-icons/react';
import VersionPill from '../../components/VersionPill';

// Phase 78ad — Booking nav simplified to just Home and New Booking.
// "My Trips" was removed because it deep-linked to ?tab=pending which
// undermined the tile-chooser UX. Pilots / bookers now always start at
// Home and tap a status tile.
const NAV = [
  { path: '/booking', label: 'Home', icon: House, end: true },
  { path: '/booking/new', label: 'New Booking', icon: Plus },
];

export default function BookingLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#F7F7F7]" data-testid="booking-layout">
      <header className="bg-[#0A0A0A] text-white px-4 py-3 flex items-center justify-between sticky top-0 z-40">
        <div className="flex items-center gap-4">
          <img src="/carloo-logo.png" alt="Carloo" className="h-8 invert" />
          <div className="hidden sm:block h-6 w-px bg-white/20" />
          <nav className="flex items-center gap-1">
            {NAV.map(item => (
              <NavLink key={item.path} to={item.path} end={item.end}
                className={({ isActive }) => `flex items-center gap-2 px-3 py-2 text-sm transition-all ${isActive ? 'bg-[#002FA7] text-white' : 'text-white/60 hover:text-white'}`}>
                <item.icon size={16} /> <span className="hidden sm:inline">{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          {/* Phase 76u — version pill so support knows which build the user is on. */}
          <VersionPill className="!bg-white/10 !text-white/70" />
          <span className="text-xs text-white/40 hidden sm:block">{user?.name}</span>
          <button className="relative p-2" data-testid="booking-notifications">
            <Bell size={20} className="text-white/60" />
          </button>
          <button
            data-testid="booking-logout-button"
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 text-sm text-white/60 hover:text-[#FF3333] hover:bg-white/5 transition-all"
          >
            <SignOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      </header>
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
}
